import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";
import { generatePath, useLocation, useRouteMatch } from "react-router";

import { DICOM_VIEWER } from "@src/common/styles/const";
import useProfile, {
  hasAccessToAdminPanel,
} from "@src/modules/App/hooks/useProfile";
import { ReactComponent as DevStatus } from "@src/modules/App/Sidebar/icons/dev_status.svg";
import { ReactComponent as Dicom } from "@src/modules/App/Sidebar/icons/dicom.svg";
import { ReactComponent as Group } from "@src/modules/App/Sidebar/icons/group.svg";
import { ReactComponent as Home } from "@src/modules/App/Sidebar/icons/home.svg";
import { ReactComponent as KnowledgeBase } from "@src/modules/App/Sidebar/icons/knowledge_base.svg";
import { ReactComponent as Admin } from "@src/modules/App/Sidebar/icons/admin.svg";
import {
  SidebarWrapper,
  StyledLink,
} from "@src/modules/App/Sidebar/Sidebar.components";
import routesPaths from "@src/modules/Routing/routesPaths";

const Sidebar: FunctionComponent = () => {
  const location = useLocation();
  const { t } = useTranslation();
  const { data: profileData } = useProfile();

  const adminRouteMatch = useRouteMatch(routesPaths.ADMIN.MAIN);
  const filesRouteMatch = useRouteMatch(routesPaths.PARTNER.MAIN);

  return (
    <SidebarWrapper>
      <StyledLink
        to={routesPaths.HOME}
        $isCurrent={location.pathname === routesPaths.HOME}
      >
        <Home />
        {t("Home")}
      </StyledLink>
      <StyledLink
        to={routesPaths.DEVICE_STATUS.LOCATIONS}
        $isCurrent={
          location.pathname.includes(routesPaths.DEVICE_STATUS.LOCATIONS) ||
          location.pathname.includes(routesPaths.DEVICE_STATUS.DEVICE)
        }
      >
        <DevStatus /> {t("Devices Status")}
      </StyledLink>
      <StyledLink
        to={generatePath(routesPaths.DICOM_VIEWER)}
        $isCurrent={location.pathname.startsWith(DICOM_VIEWER)}
      >
        <Dicom /> {t("DICOM Viewer")}
      </StyledLink>
      <StyledLink
        to={routesPaths.KNOWLEDGE_BASE.BASE}
        $isCurrent={location.pathname.includes(routesPaths.KNOWLEDGE_BASE.BASE)}
      >
        <KnowledgeBase /> {t("Knowledge Base")}
      </StyledLink>
      {!!profileData?.isDistributor && (
        <StyledLink
          to={generatePath(routesPaths.PARTNER.MAIN)}
          $isCurrent={!!filesRouteMatch}
        >
          <Group />
          {t("Partner's Portal")}
        </StyledLink>
      )}
      {hasAccessToAdminPanel(profileData) && (
        <StyledLink
          to={generatePath(routesPaths.ADMIN.MAIN)}
          $isCurrent={!!adminRouteMatch}
        >
          <Admin />
          {t("Admin Panel")}
        </StyledLink>
      )}
    </SidebarWrapper>
  );
};

export default Sidebar;
